import { v4 as uuidv4 } from 'uuid';

export function generateUniqueFileName(originalName: string): string {
  const parts = originalName.split('.');
  const extension = parts.pop() || '';
  const name = parts.join('.');
  return `${name}_${uuidv4()}.${extension}`;
}

// Matches the `_<uuid>` that generateUniqueFileName inserts before the extension.
const UNIQUE_SUFFIX =
  /_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?=\.[^.]*$|$)/i;

/**
 * Inverse of generateUniqueFileName. The draft stores the unique S3 key, but the MFE and the
 * page should show the name the user recognises, so the uuid is stripped on the way back in.
 */
export function stripUniqueFileNameSuffix(fileName: string): string {
  return fileName.replace(UNIQUE_SUFFIX, '');
}
